import axios from "axios"

const HYGRAPH_ENDPOINT = process.env.GRAPH_CMS_MUTATION_URL
const HYGRAPH_PAT = process.env.GATSBY_HYGRAPH_MUTATION_TOKEN

const fields2 = {
  "X-Amz-Date": "date",
  key: "key",
  "X-Amz-Signature": "signature",
  "X-Amz-Algorithm": "algorithm",
  policy: "policy",
  "X-Amz-Credential": "credential",
  "X-Amz-Security-Token": "securityToken",
}

const createAssetMutation = `
  mutation CreateAsset($filename: String!) {
    createAsset(data: {fileName: $filename}) {
      id
      url
      upload {
        status
        expiresAt
        requestPostData {
          url
          date
          key
          signature
          algorithm
          policy
          credential
          securityToken
        }
      }
    }
  }
`

// const publishAssetMutation = `
//   mutation PublishAsset($id: ID!) {
//     publishAsset(where: {id: $id}, to: [PUBLISHED]) {
//       id
//       url
//     }
//   }
// `

export const uploadAndPublishFileToCMS = async file => {
  if (!file) {
    console.error("No file provided")
    return "NO FILE"
  }
  try {
    const {
      assetId,
      uploadInfo,
      uploadDestinationUrl,
    } = await getFileUploadUrl(file)

    const postData = uploadInfo.requestPostData

    await uploadFileToS3({ postData, file })

    // const publishedFileUrl = await publishAsset(assetId)

    return uploadDestinationUrl
  } catch (error) {
    console.error("Error in upload:", error)
    return "NO FILE"
  }
}

const getFileUploadUrl = async file => {
  try {
    const response = await axios.post(
      HYGRAPH_ENDPOINT,
      {
        query: createAssetMutation,
        variables: { filename: file.name },
      },
      {
        headers: { Authorization: `Bearer ${HYGRAPH_PAT}` },
      }
    )

    const { data, errors } = response.data
    if (errors) throw new Error(`GraphQL error: ${errors[0].message}`)

    return {
      assetId: data.createAsset.id,
      uploadInfo: data.createAsset.upload,
      uploadDestinationUrl: data.createAsset.url,
    }
  } catch (error) {
    console.error(
      "Error in Step 1:",
      error.response ? error.response.data : error.message
    )
    return "NO FILE"
  }
}

const uploadFileToS3 = async ({ postData, file }) => {
  try {
    const formData = new FormData()

    Object.entries(fields2).forEach(([key, value]) => {
      formData.append(key, postData[value])
    })

    formData.append("file", file)

    const plainObject = Object.fromEntries(formData.entries())

    await axios.post(postData.url, formData)
  } catch (error) {
    console.error(
      "Error in upload:",
      error.response ? error.response.data : error.message
    )
    return null
  }
}

// const publishAsset = async assetId => {
//   try {
//     const response = await axios.post(
//       HYGRAPH_ENDPOINT,
//       {
//         query: publishAssetMutation,
//         variables: { id: assetId },
//       },
//       {
//         headers: { Authorization: `Bearer ${HYGRAPH_PAT}` },
//       }
//     )

//     const { data, errors } = response.data
//     if (errors)
//       throw new Error(`GraphQL error on publish: ${errors[0].message}`)

//     const publishedAsset = data.publishAsset

//     return publishedAsset.url
//   } catch (error) {
//     console.error(
//       "Error in Step 3:",
//       error.response ? error.response.data : error.message
//     )
//     return null
//   }
// }
